import { Component } from 'react';
import Form from './Form.js';
import Preview from './Preview.js';
import LimitInfo from './LimitInfo.js';
import './Main.scss';

class Main extends Component {
	constructor(props) {
		super(props);
		this.state = {
			url: '',
			title: '',
			descr: '',
			keywords: '',
			brand: window.localStorage.getItem('snippet-preview-brand') || '',
			rating: false,
			date: false,
			loggedIn: false,
			language: window.localStorage.getItem('snippet-preview-language') || 'English',
			logoutLink: '',
			user: {},
			limits: {},
			limitUsage: {},
		}

		this.setData = this.setData.bind(this);
		this.updateLimitUsage = this.updateLimitUsage.bind(this);
	}

	setData(field, value) {
		let data = {};
		data[field] = value;
		this.setState(data);
		const inLs = ['language', 'brand'];
		if (inLs.includes(field)) {
			window.localStorage.setItem('snippet-preview-' + field, value);
		}
	}

	async componentDidMount() {
		const urlParams = new URLSearchParams(window.location.search);
		const forceFree = urlParams.get('free') || false;
		const postData = new FormData();
		if (forceFree) {
			postData.append('free', true);
		}

		await fetch('ajax/session.php', {
			method: 'POST',
			body: postData,
		})
		.then((response) => response.json())
		.then((data) => {
			let limits = data.planData.limits
			? {
				daily: data.planData.limits.daily ? data.planData.limits.daily['snippet-preview'] : 0,
				monthly: data.planData.limits.monthly ? data.planData.limits.monthly['snippet-preview'] : 0,
			} : {
				daily: 0,
				monthly: 0,
			}
			this.setState({
				loggedIn: !!data.loggedIn,
				user: data.user,
				logoutLink: data.logoutLink,
				limitUsage: data.limitUsage,
				limits: limits,
				permissions: data.planData.permissions || [],
			});
		})
		.catch((error) => {
			console.error(error);
			this.setState({
				loggedIn: false
			});
		});
	}

	updateLimitUsage(limitName) {
		const limits = [];
		const newState = {};
		let newLimitUsage = {
			daily: {},
			monthly: {},
		};
		if (this.state.limits.daily) {
			limits.push('daily-' + limitName);
			newLimitUsage.daily = this.state.limitUsage.daily + 1;
		}
		if (this.state.limits.monthly) {
			limits.push('monthly-' + limitName);
			newLimitUsage.monthly = this.state.limitUsage.monthly + 1;
		}
		newState.limitUsage = newLimitUsage;
		const formData = new FormData();
		formData.append('uid', this.state.user.id);
		formData.append('limits', JSON.stringify(limits));

		fetch('ajax/update-limit-usage.php', {
			method: 'POST',
			body: formData,
		});

		this.setState(newState);
	}

	render() {
		const {user, logoutLink, loggedIn, limits, limitUsage, permissions} = this.state;
		let userInfo = '';

		const urlParams = new URLSearchParams(window.location.search);
		const iframe = urlParams.get('iframe');
		const free = urlParams.get('free');
		if (loggedIn && iframe && !free) {
			userInfo = (<p class="user-info"><b class="user-email">{user.name}</b> <a href={logoutLink}>Log out</a></p>);
		}
		let limitInfo = '';
		if (limits.daily || limits.monthly) {
			limitInfo = <LimitInfo
			dailyUsage={limitUsage.daily}
			dailyLimit={limits.daily}
			monthlyUsage={limitUsage.monthly}
			monthlyLimit={limits.monthly}
			planName={user.plan}
			/>
		}

		let isDailyLimitUsed = limits.daily && limitUsage.daily >= limits.daily;
		let isMonthlyLimitUsed = limits.monthly && limitUsage.monthly >= limits.monthly;
		let isAnyLimitUsed = isDailyLimitUsed || isMonthlyLimitUsed;

		return (
			<>
			{userInfo}
			{limitInfo}
			<div className="tool">
				<Form
					changeCallback={this.setData}
					url={this.state.url}
					title={this.state.title}
					descr={this.state.descr}
					brand={this.state.brand}
					keywords={this.state.keywords}
					language={this.state.language}
					rating={this.state.rating}
					date={this.state.date}
					isPro={permissions && permissions.includes('snippet-preview-ai')}
					langDetection={permissions && permissions.includes('snippet-preview-lang-detect')}
					isLimitUsed={isAnyLimitUsed}
					updateLimitUsage={this.updateLimitUsage}
				 />
				<Preview
					url={this.state.url || 'https://diagnoseo.com/snippet-preview'}
					title={this.state.title || 'This is an exemplary title that grabs attention | Example'}
					descr={this.state.descr || 'This is exemplary meta description text that effectively captures attention, summarizes key content, and encourages users to click for more information.'}
					keywords={this.state.keywords}
					brand={this.state.brand}
					rating={this.state.rating}
					date={this.state.date}
				/>
			</div>
			</>
		)
	}
}

export default Main;